import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ColorsService {

  constructor() { }
  private message = new BehaviorSubject('blue');
  portMessage = this.message.asObservable();

  async loginColors(){
    let Color:any={
     PrimaryColor:"rgb(234,250,254)",
     headerColor:'#1976d2'
     
    }
     const res = await Color
   return  res
 }
  async colors(message:any,screen:any){
   // console.log(message)
    message=JSON.parse(sessionStorage.getItem('userData')!);
    screen=JSON.parse(sessionStorage.getItem('screenData')!);

    this.message.next(message)

    let data:any=this.message
    //console.log(data)

   let Color:any={
    PrimaryColor: data?._value||"rgb(234,250,254);",
    headerColor:screen?.headerColor||'#064872',
    sideBarColor:screen?.sideBarColor||'#d2e1f5'
    
   }
  // console.log(Color)
    const res = await Color
  return  res
}
  
}
